// Realtime channel helper — process-unique channel topics.
//
// supabase-js v2.110 (bumped in #170) changed RealtimeClient.channel(topic): it
// now RETURNS AN EXISTING channel when one with the same `realtime:${topic}` is
// still registered, and RealtimeChannel.on() THROWS
//   "cannot add `postgres_changes` callbacks for realtime:<topic> after `subscribe()`."
// when called on an already-subscribed channel. removeChannel() only
// de-registers a channel AFTER its async unsubscribe() round-trips, so a React
// effect that re-runs (unstable dep) or a component that remounts (navigation)
// and re-subscribes to a STATIC topic collides with the not-yet-removed channel.
// The throw is raised from the subscribe effect during React's commit phase, so
// it escapes to the root and blanks the whole app.
//
// Fix: give every subscription a topic that is unique for the life of the tab,
// so channel() always creates a fresh channel and on() is never called on a
// subscribed one. The callers still pass a readable, scoped base name (used in
// realtime logs); we append a monotonic suffix. Pair with
// supabase.removeChannel(channel) in the effect cleanup exactly as before.
//
// Only use this for one-way postgres_changes subscriptions (every current use).
// A shared broadcast/presence channel — where multiple clients MUST agree on a
// topic — must NOT go through here.
let channelSeq = 0

export function uniqueTopic(baseName: string): string {
  channelSeq += 1
  return `${baseName}#${channelSeq}`
}
